export default __webpack_public_path__ + "static/media/store_svg12.ebbee843.svg";